import React from 'react';
import DetailedHeader from '../../../../components/ProjectDetailedPageComponents/DetailedHeader';
import Seo from '../../../../components/Misc/Seo';
import ImageSlider from '../../../../components/Misc/ImageSlider';
import projectImage1 from '../../../../assets/images/work/motor-control/Motor Control_Slider.webp';
import projectImage2 from '../../../../assets/images/work/motor-control/Motor Control_Slider_2.webp';
import projectImage3 from '../../../../assets/images/work/motor-control/Motor Control_Slider_3.webp';
import projectImage4 from '../../../../assets/images/work/motor-control/Motor Control_Slider_4.webp';
import projectImage5 from '../../../../assets/images/work/motor-control/Motor Control_Slider_5.webp';
import projectImage6 from '../../../../assets/images/work/motor-control/Motor Control_Slider_6.webp';

import Data_MotorControl from './Data_MotorControl';

function Work_MotorControl() {
    const canonical = 'https://studio.norcat.org/OurWork/motor-control';
    const title = 'Motor Control | Studio NORCAT - Driven by experiences that matter.';
    const description = 'Developed by Studio NORCAT, Motor Control is a VR training experience that helps learners practise electrical troubleshooting, motor control procedures, and job-ready decision-making in a safe simulated environment.';

    return (
        <>
            <Seo
                title={title}
                description={description}
                canonical={canonical}
                ogTitle={title}
                ogDescription={description}
                ogImage={`${window.location.origin}${projectImage1}`}
                ogImageAlt="Preview of the Motor Control VR training project"
                twitterTitle={title}
                twitterDescription={description}
                twitterImage={`${window.location.origin}${projectImage1}`}
                twitterImageAlt="Preview of the Motor Control VR training project"
            />
            <DetailedHeader
                heading="Building Job-Ready Electrical Skills Safely"
                client="NETCO / IBEW"
                service="Virtual Reality"
                date="2025"
            />
            <ImageSlider
                noArt="true"
                swiperNav="true"
                useButtonNav="true"
                youtubeUrl="https://www.youtube.com/watch?v=y5LDVseL2n4"
                images={[
                    {
                        image: projectImage1,
                        alt: 'Motor Control project screenshot 1',
                    },
                    {
                        image: projectImage2,
                        alt: 'Motor Control project screenshot 2',
                    },
                    {
                        image: projectImage3,
                        alt: 'Motor Control project screenshot 3',
                    },
                    {
                        image: projectImage4,
                        alt: 'Motor Control project screenshot 4',
                    },
                    {
                        image: projectImage5,
                        alt: 'Motor Control project screenshot 5',
                    },
                    {
                        image: projectImage6,
                        alt: 'Motor Control project screenshot 6',
                    },
                ]}
            />

            {Data_MotorControl.content}
        </>
    );
}

export default Work_MotorControl;
